import { Routes } from '@angular/router';
import { TermsAndConditionsPageComponent } from './terms-and-conditions-page/terms-and-conditions-page.component';
import { PrivacyPolicyPageComponent } from './privacy-policy-page/privacy-policy-page.component';

export const termsPageChildren: Routes = [
  { path: 'terms', component: TermsAndConditionsPageComponent },
  { path: 'privacy', component: PrivacyPolicyPageComponent }
];
